// moment trenger DD MM og YYYY i uppercase, mens asp.net bruker lowercase for dd og yyyy
export const NorskDato = 'DD.MM.YYYY';
export const NorskDatoMedTid = 'DD.MM.YYYY hh:mm';
export const BrowserDato = 'YYYY-MM-DD';
